export default __webpack_public_path__ + "static/14-505633cc46a57edfb28143f4b5e4611b.png";